import {Component, forwardRef, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CatalogService} from 'app/Services/CatalogManagement/catalog.service';
import {LoginService} from 'app/Services/login.service';
import {MacroService} from 'app/Services/CatalogManagement/macro.service';
import {SystemService} from 'app/Services/system.service';
import {UserActionBaseComponent} from '../userAction-base.component';

@Component({
    selector: 'useraction-convert-orderdetails-to-supplierdetails',
    templateUrl: './useraction-convert-orderdetails-to-supplierdetails.component.html',
    styleUrl: "./useraction-convert-orderdetails-to-supplierdetails.component.css",
    providers: [
        {
            provide: UserActionBaseComponent,
            useExisting: forwardRef(() => UseractionConvertOrderdetailsToSupplierdetailsComponent)
        }
    ],
    standalone: false
})
export class UseractionConvertOrderdetailsToSupplierdetailsComponent extends UserActionBaseComponent implements OnInit {
    noCatalogSupplier: boolean = false;
    editMaster: boolean = false;
    removeConvertedPrices: boolean = true;

    availablePriceTypes: { key: string; label: string }[] = [];
    selectedPriceTypes: string[] = [];

    constructor(
        public loginService: LoginService,
        public macroService: MacroService,
        private catalogService: CatalogService,
        private systemService: SystemService,
        private translate: TranslateService) {
        super(loginService, macroService);
        this.noCatalogSupplier = !this.catalogService.catalog.supplier.supplierName;
    }

    override async ngOnInit(): Promise<void> {
        this.userActionToggleStartButton.emit(!this.noCatalogSupplier);
        await this.loadPriceTypes();
    }

    private async loadPriceTypes(): Promise<void> {
        const priceTypes = await this.catalogService.getDistinctPriceTypes(
            this.catalogService.catalog.id,
            this.loginService.currentUser.customerId);

        this.availablePriceTypes = priceTypes
            .filter(priceType => !!priceType)
            .map(priceType => ({key: priceType, label: this.buildLabel(priceType)}));
        this.selectedPriceTypes = this.availablePriceTypes.map(priceType => priceType.key);
    }

    private buildLabel(priceType: string): string {
        const translated = this.translate.instant(priceType);
        const prettified = priceType.split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
        return translated && translated !== priceType ? `${prettified} (${translated})` : prettified;
    }

    public override async canStartMacro(): Promise<boolean> {
        if (this.availablePriceTypes.length > 0 && this.selectedPriceTypes.length === 0) {
            this.systemService.notifyInfo(this.translate.instant('Bitte wählen Sie mindestens einen Preistyp aus'));
            return false;
        }
        return true;
    }

    public createParameterStringAsJsonString(): string {
        return JSON.stringify({
            editMaster: this.editMaster,
            priceTypes: this.selectedPriceTypes,
            removeConvertedPrices: this.removeConvertedPrices
        });
  }

    public parseParameter(parameter: string) {
        if (!parameter)
            return;
        try {
            const parsed = JSON.parse(parameter);
            this.editMaster = parsed.editMaster;
            this.removeConvertedPrices = parsed.removeConvertedPrices ?? true;
            if (parsed.priceTypes)
                this.selectedPriceTypes = parsed.priceTypes;
        } catch (error) {
            console.error('Invalid JSON string provided:', error);
        }
    }
}
